module.exports = __webpack_public_path__ + "static/media/deco-benefit-colored.5ea436b9.svg";